<template>
  <div class="home">
    <div class="header">
      <Header></Header>
    </div>
    <!-- 中心内容出口 -->
    <div class="main">
      <router-view></router-view>
    </div>
    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header/index";
import Footer from "./components/Footer/index";
export default {
  name: "Home",
  components: {
    Header,
    Footer
  },
  data() {
    return {
     
    };
  },
};
</script>
<style lang="scss" scoped>
.home {
overflow: hidden;
text-align: center;
background: #ffffff;
//   .header {
//     height: 300px;  //记得改成设计图高度
//   }
  .main {
    // min-height: 1200px;   //记得改成设计图高度
  }
  .footer {
    // height: 270px;   //记得改成设计图高度
  }
}
</style>
